import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import AddOne from "./pages/AddOne";
import NotFound from "./pages/NotFound";

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/add-one" element={<AddOne />} />

          {/* Catch all route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
